/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Partner_Home_Waiting_BodyInputs */



/**
* | output |
* | --- |
* | "Nobody has accepted the invitation for these customers yet. Open a customer to resend it." |
*
* @param {Partner_Home_Waiting_BodyInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const partner_home_waiting_body = /** @type {((inputs?: Partner_Home_Waiting_BodyInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Partner_Home_Waiting_BodyInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ ("Bei diesen Kunden hat noch niemand die Einladung angenommen. Öffnen Sie einen Kunden, um sie erneut zu senden.")
	return /** @type {LocalizedString} */ ("Nobody has accepted the invitation for these customers yet. Open a customer to resend it.")
});